﻿import React, { PropsWithChildren } from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../resources/ResourcesStore";
import { injectFromApp } from "../../shared-components/inject";
import type { IUploadStore } from "../UploadStore";
import { injectFromAppUpload } from "../inject";
import { newShortGuid } from "../../util/types/guid";
import { action, observable } from "mobx";

interface IDragAndDropComponentProps {
    resourcesStore?: IResourcesStore;
    uploadStore?: IUploadStore;
}

@injectFromApp<IDragAndDropComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
}))

@injectFromAppUpload<IDragAndDropComponentProps>((stores) => ({
    uploadStore: stores.uploadStore,
}))

@observer
export class DragAndDropComponent extends React.Component<PropsWithChildren<IDragAndDropComponentProps>> {
    state = {
        dragging: false,
    };

    private dragCounter = 0;

    @observable
    private inputStateKey = newShortGuid(); //needed to reset input files on 2nd browse, so it retriggers file selection

    private readonly onDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    private readonly onDragEnter = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.dragCounter++;

        if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
            const itemKind = event.dataTransfer.items[0].kind;
            //Only set dragging when items are of kind "file"
            if (itemKind === "file") {
                this.setState({
                    dragging: true,
                });
            }
        }
    };

    private readonly onDragLeave = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter === 0) {
            this.setState({
                dragging: false,
            });
        }
    };

    @action
    private readonly onDrop = (event) => {
        const { uploadStore } = this.props;
        const { preventInputOfNewFiles } = uploadStore!;
        if (preventInputOfNewFiles) return;

        event.preventDefault();
        event.stopPropagation();
        this.setState({
            dragging: false,
        });
        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            uploadStore!.addSelectedFiles(event.dataTransfer.files);
            event.dataTransfer.clearData();
            this.dragCounter = 0;
            this.inputStateKey = newShortGuid();
        }
    };

    render() {
        const { resourcesStore, uploadStore } = this.props;
        const { preventInputOfNewFiles } = uploadStore!;
        const { resources } = resourcesStore!;

        return (
            <div key={ this.inputStateKey }
                 id={ "drag-and-drop-container" }
                 className={ this.state.dragging && !preventInputOfNewFiles ? "dragging" : "" }
                 onDragEnter={ this.onDragEnter }
                 onDragLeave={ this.onDragLeave }
                 onDragOver={ this.onDragOver }
                 onDrop={ this.onDrop }>
                <div id={ "drop-files-here" }>
                    <p>{ resources.DropImagesHere }</p>
                </div>
                { this.props.children }
            </div>
        );
    }
}
